module.exports = __webpack_public_path__ + "yz/img/app.bbaa1a89.jpg";